// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***************************************Ecras pequenos (SmartPhones)***************************************/
@media only screen and (max-width: 600px) {
  .carousel_container {
    display: flex;
    flex-direction: column;
    background: var(--ColorSecondary);
    box-shadow: 3px 6px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    padding: 10px;
    width: auto;
  }
  .carousel_box button {
    display: none;
  }
  .carousel_title {
    display: flex;
    flex-direction: row;
  }
  .carousel_dots {
    margin-left: auto;
  }
  .carousel_dots button {
    border-radius: 100%;
    border: none;
    width: 1px;
    height: 10px;
    margin: 2px;
  }
}
/***************************************Ecras Grandes (PCs)***************************************/
@media only screen and (min-width: 600px) {
    .carousel_container {
        display: flex;
        flex-direction: column;
        background: var(--ColorSecondary);
        box-shadow: 3px 6px 4px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        padding: 10px;
        width: 30%;
      }
      .carousel_box {
        display: flex;
        flex-direction: row;
        width: 100%;
      }
      .carousel_box button {
        border: none;
        background-color: var(--ColorSecondary);
      }
      .carousel_slider {
        width: 100%;
        padding: 0;
      }
      .carousel_slider_content{
        color: white;
      }
      .carousel_title {
        display: flex;
        flex-direction: row;
      }
      .carousel_dots {
        margin-left: auto;
      }
      .carousel_dots button {
        border-radius: 100%;
        border: none;
        width: 1px;
        height: 10px;
        margin: 2px;
      }
      .carousel_box button svg:hover {
        background-color: #ffffff34;
        border-radius: 100%;
      }
      .carousel_box button svg {
        justify-content: center;
        align-items: center;
        justify-self: center;
        margin: 0.1rem;
        transition: 200ms ease;
      }
      .carousel_box button:disabled svg {
        opacity: 0.5;
      }
}
`, "",{"version":3,"sources":["webpack://./src/components/carouselCard/carouselCard.css"],"names":[],"mappings":"AAAA,2GAA2G;AAC3G;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,iCAAiC;IACjC,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,WAAW;EACb;AACF;AACA,kGAAkG;AAClG;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,iCAAiC;QACjC,2CAA2C;QAC3C,mBAAmB;QACnB,aAAa;QACb,UAAU;MACZ;MACA;QACE,aAAa;QACb,mBAAmB;QACnB,WAAW;MACb;MACA;QACE,YAAY;QACZ,uCAAuC;MACzC;MACA;QACE,WAAW;QACX,UAAU;MACZ;MACA;QACE,YAAY;MACd;MACA;QACE,aAAa;QACb,mBAAmB;MACrB;MACA;QACE,iBAAiB;MACnB;MACA;QACE,mBAAmB;QACnB,YAAY;QACZ,UAAU;QACV,YAAY;QACZ,WAAW;MACb;MACA;QACE,2BAA2B;QAC3B,mBAAmB;MACrB;MACA;QACE,uBAAuB;QACvB,mBAAmB;QACnB,oBAAoB;QACpB,cAAc;QACd,sBAAsB;MACxB;MACA;QACE,YAAY;MACd;AACN","sourcesContent":["/***************************************Ecras pequenos (SmartPhones)***************************************/\n@media only screen and (max-width: 600px) {\n  .carousel_container {\n    display: flex;\n    flex-direction: column;\n    background: var(--ColorSecondary);\n    box-shadow: 3px 6px 4px rgba(0, 0, 0, 0.25);\n    border-radius: 10px;\n    padding: 10px;\n    width: auto;\n  }\n  .carousel_box button {\n    display: none;\n  }\n  .carousel_title {\n    display: flex;\n    flex-direction: row;\n  }\n  .carousel_dots {\n    margin-left: auto;\n  }\n  .carousel_dots button {\n    border-radius: 100%;\n    border: none;\n    width: 1px;\n    height: 10px;\n    margin: 2px;\n  }\n}\n/***************************************Ecras Grandes (PCs)***************************************/\n@media only screen and (min-width: 600px) {\n    .carousel_container {\n        display: flex;\n        flex-direction: column;\n        background: var(--ColorSecondary);\n        box-shadow: 3px 6px 4px rgba(0, 0, 0, 0.25);\n        border-radius: 10px;\n        padding: 10px;\n        width: 30%;\n      }\n      .carousel_box {\n        display: flex;\n        flex-direction: row;\n        width: 100%;\n      }\n      .carousel_box button {\n        border: none;\n        background-color: var(--ColorSecondary);\n      }\n      .carousel_slider {\n        width: 100%;\n        padding: 0;\n      }\n      .carousel_slider_content{\n        color: white;\n      }\n      .carousel_title {\n        display: flex;\n        flex-direction: row;\n      }\n      .carousel_dots {\n        margin-left: auto;\n      }\n      .carousel_dots button {\n        border-radius: 100%;\n        border: none;\n        width: 1px;\n        height: 10px;\n        margin: 2px;\n      }\n      .carousel_box button svg:hover {\n        background-color: #ffffff34;\n        border-radius: 100%;\n      }\n      .carousel_box button svg {\n        justify-content: center;\n        align-items: center;\n        justify-self: center;\n        margin: 0.1rem;\n        transition: 200ms ease;\n      }\n      .carousel_box button:disabled svg {\n        opacity: 0.5;\n      }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
